export default {
      id: "icon-difficulte3-usage",
      viewBox: "0 0 99 30",
      url: __webpack_public_path__ + "icons.svg#icon-difficulte3",
      toString: function () {
        return this.url;
      }
    }